import Vue, { VueConstructor } from "vue";
import { TranslateResult } from "vue-i18n";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";

export interface StepData {
  name: string;
  step: number;
  required?: boolean;
  doNotSaveStepProgress?: boolean;
  buttonLabel?: TranslateResult;
  component: VueConstructor<Vue>;
}
export interface FormFileData {
  data: FileList | FileData | null;
}

export enum TaxCountry {
  USA = "USA",
  CANADA = "Canada",
}

export enum TinType {
  SSN_ITIN = "SSN / ITIN",
  EIN = "EIN",
  SIN = "SIN",
}

export interface TaxpayerInfo {
  legalFirstName: string;
  legalMiddleName?: string;
  legalLastName: string;
  businessName?: string;
  addressLine1: string;
  addressLine2?: string;
  zipCode: string;
  city: string;
  state: string;
  country: TaxCountry;
}

export interface TaxCertification {
  tinCorrect: boolean;
  usOrCanadaPerson: boolean;
  signature: string;
}

export interface TaxFormDraft {
  residesInUsaOrCanada?: boolean;
  taxpayerInfo?: TaxpayerInfo;
  tinType?: TinType;
  taxId?: string;
  certification?: TaxCertification;
}
